{
  "chat": {
    "title": "Chat",
    "empty": "Todavía no hay chats",
    "loadError": "No se ha podido cargar esta conversación",
    "messagePlaceholder": "Mensaje",
    "typing": "{{name}} está escribiendo…",
    "typingTwo": "{{a}} y {{b}} están escribiendo…",
    "typingMany": "Varias personas están escribiendo…",
    "online": "En línea",
    "offline": "Desconectado",
    "unread": "Sin leer",
    "startDm": "Enviar un mensaje a {{name}}",
    "members": "Miembros",
    "mute": "Silenciar esta conversación",
    "unmute": "Activar el sonido de esta conversación",
    "muted": "Silenciada"
  },
  "login": {
    "title": "¡Bienvenido de nuevo!",
    "description": "Introduce tu dirección de correo electrónico y te enviaremos un código para iniciar sesión.",
    "input": {
      "label": "Dirección de correo electrónico",
      "placeholder": "me@email.com"
    },
    "button": {
      "label": "Solicitar código",
      "loading": "Enviando código..."
    }
  },
  "verify": {
    "title": "Introduce el código",
    "description": "Introduce el código que te hemos enviado por correo electrónico a {{email}}.",
    "input": {
      "label": "Código de verificación",
      "placeholder": "00000000"
    },
    "button": {
      "label": "Verificar código",
      "loading": "Verificando código..."
    },
    "buttonAbort": {
      "label": "Cancelar"
    },
    "buttonResend": {
      "label": "Reenviar código"
    },
    "error": {
      "Invalid or expired OTP.": "El código ha caducado o no es válido.",
      "invalidOtp": "El código ha caducado o no es válido."
    }
  },
  "date": "{{value, datetime}}",
  "auth": {
    "logout": {
      "button": "Cerrar sesión",
      "confirmTitle": "Cerrar sesión",
      "confirmMessage": "¿Estás seguro de que quieres cerrar sesión?",
      "error": "Error al cerrar sesión. Inténtalo de nuevo."
    }
  },
  "errors": {
    "types": {
      "authentication": "Error de autenticación",
      "network": "Problema de conexión",
      "generic": "Algo ha salido mal"
    },
    "messages": {
      "sessionExpired": "Tu sesión ha caducado. Inicia sesión de nuevo.",
      "networkError": "Comprueba tu conexión a internet e inténtalo de nuevo.",
      "genericError": "Se ha producido un error inesperado. Puedes intentar actualizar la página o cerrar sesión.",
      "noOrg": "No se ha encontrado ninguna organización..."
    },
    "technical": {
      "title": "Detalles técnicos:",
      "retryAttempts": "Intentos: {{current}}/{{max}}"
    },
    "actions": {
      "tryAgain": "Intentar de nuevo",
      "loginAgain": "Iniciar sesión de nuevo",
      "logout": "Cerrar sesión",
      "moreOptions": "Más opciones",
      "chooseAction": "Elige una acción:",
      "refreshApp": "Actualizar app",
      "debugData": "Datos de depuración",
      "clearCacheRetry": "Limpiar caché y reintentar"
    }
  },
  "common": {
    "currency": "{{value, currency}}",
    "decimalSeparator": ",",
    "loading": "Cargando...",
    "cancel": "Cancelar",
    "confirm": "Confirmar",
    "error": "Error",
    "success": "Éxito",
    "time": {
      "dayAgo": "hace 1 día",
      "daysAgo": "hace {{count}} días",
      "weekAgo": "hace 1 semana",
      "weeksAgo": "hace {{count}} semanas",
      "monthsAgo": "hace {{count}} meses",
      "secondsAbbr": "s"
    },
    "profile": "Perfil"
  },
  "dashboard": {
    "error": {
      "orgNotFound": "Organización no encontrada"
    },
    "quickActions": {
      "media": {
        "title": "Todos los medios",
        "subtitle": "Explorar biblioteca"
      },
      "achievements": {
        "title": "Logros",
        "subtitle": "Ver progreso"
      },
      "profile": {
        "title": "Carné de socio",
        "subtitle": "Tus datos"
      },
      "membership": {
        "title": "Suscripción",
        "subtitle": "Ver plan"
      },
      "offers": {
        "title": "Ofertas",
        "subtitle": "Explorar disponibles"
      },
      "invite": {
        "title": "Invitar miembros",
        "subtitle": "Crear código QR"
      }
    },
    "sections": {
      "featuredVideos": "Vídeos destacados",
      "lastViewed": "Vistos recientemente",
      "bookmarkedVideos": "Elementos guardados",
      "recentAchievements": "Logros recientes",
      "viewAllAction": "Ver todo"
    }
  },
  "membership": {
    "paymentRequired": {
      "title": "Configuración de pago necesaria",
      "subtitle": "Tu suscripción se ha transferido a esta organización. Para continuar, configura tu pago con uno de los métodos de pago disponibles.",
      "paidUntilNote": "Tu periodo ya pagado se mantiene — no se te cobrará antes del {{date}}.",
      "bonusOffer_one": "Configura tu pago antes del {{date}} y recibe {{count}} mes adicional gratis.",
      "bonusOffer_other": "Configura tu pago antes del {{date}} y recibe {{count}} meses adicionales gratis.",
      "openDashboard": "Configurar el pago en el panel web",
      "openDashboardHint": "Por motivos de seguridad, la configuración del pago se realiza en tu navegador. Iniciarás sesión automáticamente.",
      "checkAgain": "He completado el pago",
      "error": "No se pudo iniciar la configuración del pago. Inténtalo de nuevo."
    },
    "title": "Suscripción",
    "status": {
      "active": "Activa",
      "inactive": "Inactiva"
    },
    "period": {
      "monthly": "Mensual",
      "yearly": "Anual"
    },
    "pricing": {
      "per": {
        "monthly": "al mes",
        "yearly": "al año"
      }
    },
    "sections": {
      "planDetails": "Detalles",
      "organization": "Organización"
    },
    "labels": {
      "billingPeriod": "Período de facturación",
      "memberSince": "Miembro desde",
      "validUntil": "Válido hasta",
      "cancelled": "Suscripción cancelada"
    },
    "organization": {
      "memberDescription": "Eres miembro de esta organización"
    },
    "management": {
      "title": "Gestionar tu suscripción",
      "description": "Para realizar cambios en tu suscripción, utiliza la WebApp de OctaHub o contacta directamente con {{organizationName}}."
    },
    "dashboard": {
      "title": "Abrir panel",
      "subtitle": "Gestiona tu suscripción y ajustes",
      "openError": "No se ha podido abrir el panel. Inténtalo de nuevo."
    }
  },
  "media": {
    "download": {
      "button": "Descargar",
      "available": "Disponible sin conexión"
    },
    "screens": {
      "bookmarks": "Vídeos guardados",
      "lastViewed": "Vídeos vistos recientemente",
      "library": "Medios"
    },
    "bookmark": {
      "save": "Guardar",
      "saved": "Guardado",
      "bookmarkLabel": "Marcador",
      "bookmarkedLabel": "Guardado"
    },
    "folder": {
      "itemCount_one": "{{count}} elemento",
      "itemCount_other": "{{count}} elementos",
      "folderDescription": "Carpeta con {{count}} elementos"
    },
    "sharedFolders": {
      "upload": "Subir",
      "newFolder": "Nueva carpeta",
      "folderNamePlaceholder": "Nombre de la carpeta...",
      "uploading": "Subiendo...",
      "uploadProgress": "{{progress}}%",
      "uploadSuccess": "Archivo subido correctamente",
      "uploadError": "Error al subir",
      "uploadErrorMessage": "Se ha producido un error al subir. Inténtalo de nuevo.",
      "uploadSubtitle": "Subir un archivo a esta carpeta",
      "newFolderSubtitle": "Crear una nueva subcarpeta"
    },
    "navigation": {
      "previous": "Anterior",
      "next": "Siguiente"
    },
    "relatedVideos": "Contenido relacionado",
    "delete": {
      "button": "Eliminar",
      "confirmTitle": "Eliminar medio",
      "confirmMessage": "¿Estás seguro de que quieres eliminar este elemento? Esta acción no se puede deshacer.",
      "success": "Medio eliminado correctamente",
      "error": "Error al eliminar",
      "errorMessage": "No se ha podido eliminar este medio. Inténtalo de nuevo.",
      "errorInUse": "Este medio se utiliza en una o más ofertas y no se puede eliminar."
    }
  },
  "achievements": {
    "title": "Logros",
    "subtitle": "Tus logros conseguidos",
    "count_zero": "Ningún logro conseguido",
    "count_one": "{{count}} logro conseguido",
    "count_other": "{{count}} logros conseguidos",
    "earned": "Conseguido {{time}}",
    "emptyState": {
      "title": "Aún no hay logros",
      "description": "¡Completa cursos y actividades para conseguir tu primer logro!"
    }
  },
  "noOrg": {
    "title": "No se han encontrado organizaciones",
    "description": "Aún no tienes acceso a ninguna organización. Contacta con tu administrador para obtener acceso o inténtalo más tarde.",
    "actions": {
      "title": "Lo que puedes hacer:",
      "contactAdmin": "Contactar con el administrador de tu organización",
      "askInvitation": "Solicitar una invitación",
      "checkAccount": "Comprobar si estás usando la cuenta correcta",
      "tryRelogin": "Intentar cerrar sesión y volver a iniciarla"
    }
  },
  "offers": {
    "title": "Ofertas",
    "detailsTitle": "Detalles de la oferta",
    "notFound": "Oferta no encontrada",
    "notFoundMessage": "No se ha podido encontrar esta oferta",
    "noOffers": "No hay ofertas disponibles en este momento",
    "purchased": "Comprado",
    "free": "Gratis",
    "purchaseWebOnly": "Compra solo en la web-app",
    "claimOffer": "Canjear oferta",
    "purchase": "Comprar",
    "purchasedBadge": "✓ Ya posees esta oferta",
    "youOwnThis": "Tienes acceso a todo el contenido de esta oferta",
    "missingAchievements": "⚠️ No tienes los logros necesarios para esta oferta. Aún te falta: {{missing}}",
    "mobileNotAvailable": "⚠️ Las compras no están disponibles en la app móvil",
    "mobileNotAvailableSubtext": "Visita nuestro sitio web para comprar esta oferta",
    "price": "Precio:",
    "includedContent": "Contenido incluido",
    "includedAchievements": "Logros incluidos",
    "videoCount_one": "{{count}} vídeo",
    "videoCount_other": "{{count}} vídeos",
    "audioCount_one": "{{count}} audio",
    "audioCount_other": "{{count}} audios",
    "pdfCount_one": "{{count}} PDF",
    "pdfCount_other": "{{count}} PDFs",
    "documentCount_one": "{{count}} documento",
    "documentCount_other": "{{count}} documentos",
    "imageCount_one": "{{count}} imagen",
    "imageCount_other": "{{count}} imágenes",
    "achievementCount_one": "{{count}} logro",
    "achievementCount_other": "{{count}} logros",
    "paymentDenied": {
      "title": "Pago no disponible",
      "description": "Esta oferta no está disponible para su compra en tu región"
    },
    "pricing": {
      "netAmount": "Importe neto"
    },
    "errors": {
      "general": "Error",
      "purchaseFailed": "Error al procesar la compra",
      "webOnly": "Las compras solo están disponibles en la versión web"
    },
    "success": {
      "claimed": "¡Oferta canjeada correctamente!"
    },
    "paymentProviders": {
      "selectTitle": "Seleccionar método de pago",
      "selectSubtitle": "Elige cómo quieres pagar",
      "stripe": {
        "name": "Stripe",
        "description": "Tarjeta de crédito, tarjeta de débito, Apple Pay, Google Pay"
      },
      "paypal": {
        "name": "PayPal",
        "description": "Saldo de PayPal, tarjeta de crédito, cuenta bancaria"
      }
    },
    "payment": {
      "processing": "Procesando tu pago...",
      "success": {
        "title": "¡Pago realizado correctamente!",
        "message": "Tu compra se ha completado correctamente. Ahora tienes acceso al contenido.",
        "viewOffer": "Ver oferta",
        "backToOffers": "Volver a ofertas"
      },
      "pending": {
        "title": "Pago en proceso",
        "message": "Tu pago aún se está procesando. Puede tardar unos instantes...",
        "checkStatus": "Comprobar estado"
      },
      "failed": {
        "title": "Pago fallido",
        "message": "Tu pago no se ha podido completar. Inténtalo de nuevo.",
        "tryAgain": "Intentar de nuevo"
      }
    }
  },
  "orgSelection": {
    "title": "Seleccionar organización",
    "subtitle": "Elige una organización para continuar",
    "switchOrg": "Cambiar de organización",
    "switchOrgSubtitle": "Cambiar a otra organización",
    "currentOrg": "Actual"
  },
  "profile": {
    "myPurchases": "Mis compras",
    "idPrefix": "ID: "
  },
  "settings": {
    "language": {
      "title": "Idioma",
      "subtitle": "Selecciona tu idioma preferido",
      "systemDefault": "Predeterminado del sistema"
    },
    "notifications": {
      "title": "Notificaciones",
      "subtitle": "Elige sobre qué quieres recibir notificaciones",
      "chat": "Mensajes de chat",
      "chatHint": "Recibe notificaciones de los mensajes nuevos de tus conversaciones",
      "seeAll": "Ver todas las notificaciones",
      "permissionDenied": "Las notificaciones de esta aplicación están desactivadas en los ajustes de tu dispositivo."
    }
  },
  "openWebApp": "Abrir Web App",
  "openWebAppSubtext": "Gestiona tu cuenta, compras y más en {{url}}",
  "openWebAppError": "No se ha podido abrir la web app. Inténtalo de nuevo.",
  "invite": {
    "title": "Invitar miembros",
    "selectPlan": "Seleccionar un plan de membresía",
    "selectGroup": "Seleccionar un grupo",
    "generating": "Generando...",
    "scanToJoin": "Escanea este código QR para unirte",
    "createAnother": "Crear otro",
    "error": {
      "createFailed": "No se pudo crear la invitación. Inténtalo de nuevo.",
      "noPlans": "No hay planes de membresía disponibles."
    }
  },
  "notifications": {
    "title": "Notificaciones",
    "empty": "Todavía no hay notificaciones",
    "markAllRead": "Marcar todas como leídas",
    "unread": "Sin leer",
    "loadError": "No se han podido cargar las notificaciones",
    "chat": {
      "messageGroup": {
        "title": "{{channel}}",
        "body": "{{sender}}: {{preview}}"
      },
      "messageDm": {
        "title": "{{sender}}",
        "body": "{{preview}}"
      }
    },
    "common": {
      "newMessage": "Nuevo mensaje"
    }
  }
}
